import axios from 'axios'
import Qs from 'qs'
import $ from 'jquery'
const throttle = require('lodash.throttle')

const loadNewsSensor = document.querySelector(
  '.news-infinite-scroll__load-sensor'
)
const loadIfDistance = 100
let canLoad = true

const loadNextPost = e => {
  const exclude = [...document.querySelectorAll('.single-news__main')].map(x =>
    parseInt(x.dataset.postId)
  )
  axios
    .post(
      theme.ajaxurl,
      Qs.stringify({
        action: 'news_infinite_load',
        exclude
      })
    )
    .then(result => {
      const { data: html } = result
      $(html).insertBefore('.news-infinite-scroll')
      const id = html.match(/data-post-id=\"(\d+)\"/)[1]
      setTimeout(() => {
        $(`[data-post-id="${id}"]`).addClass('loaded')
      }, 10)
      canLoad = true
      const closeEnoughToScroll = 100
      if (
        Math.abs(
          $(window).scrollTop() - $(`[data-post-id="${id}"]`).offset().top
        ) < closeEnoughToScroll
      ) {
        $('html, body').animate({
          scrollTop: $(`[data-post-id="${id}"]`).offset().top
        })
      }
      $('.news-infinite-scroll').removeClass('loading')
    })
    .catch(function(error) {
      console.log(error)
      $('.news-infinite-scroll').removeClass('loading')
    })
}

const loadNews = e => {
  if (!canLoad) {
    return
  }

  const viewportOffset = loadNewsSensor.getBoundingClientRect()
  const fromBottom = viewportOffset.top - window.innerHeight

  if (fromBottom <= loadIfDistance && viewportOffset.top > 0) {
    $('.news-infinite-scroll').addClass('loading')
    loadNextPost()

    canLoad = false
  }
}

const loadNewsWrapper = () => {
  $(window).scroll(throttle(loadNews, 333))
}

export default loadNewsWrapper
